// extracted by mini-css-extract-plugin
module.exports = {"toggle-switch":"_1ovLs","toggle-switch-checkbox":"_347YR","toggle-switch-label":"_3fiRB","toggle-switch-switch":"Mtvyu","doctor":"_1cDZ-","patient":"_3QYbE"};